// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---------- THEME & RESETS ---------- */
:root {
  --bg: #0b0f14;
  --card: rgba(255, 255, 255, 0.04);
  --text: #f5f7fb;
  --muted: #c9d1d9;
  --accent: #0a84ff;
  --accent-hover: #0066d9;
  --success-tint: rgba(0, 180, 0, 0.1);
  --border: rgba(255, 255, 255, 0.15);
  --border-strong: rgba(255, 255, 255, 0.25);
  --warning: #ffd166;
  --shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
  --radius-lg: 12px;
  --radius-md: 8px;
  --radius-sm: 6px;
}

@media (prefers-color-scheme: light) {
  :root {
    --bg: #f7f9fc;
    --card: #ffffff;
    --text: #0f172a;
    --muted: #475569;
    --accent: #0a84ff;
    --accent-hover: #0066d9;
    --success-tint: rgba(0, 150, 0, 0.08);
    --border: #e5e7eb;
    --border-strong: #cbd5e1;
    --warning: #b45309;
    --shadow: 0 10px 30px rgba(2, 6, 23, 0.08);
  }
}

*,
*::before,
*::after { box-sizing: border-box; }

/* ---------- CONTAINER ---------- */
.protein-tool-container {
  max-width: 760px;
  margin: 2rem auto;
  background: var(--card);
  color: var(--text);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow);
  padding: 2.25rem 2rem;
  backdrop-filter: saturate(140%) blur(4px);
}

.protein-tool-container h1 {
  margin-top: 0;
  margin-bottom: 1rem;
  font-size: clamp(1.4rem, 2.4vw, 1.9rem);
}

/* ---------- INPUT GROUPS ---------- */
.protein-input-group {
    display: flex;
  margin-bottom: 1.1rem;
}

.protein-input-group label {
  font-size: 1.05rem;
  display: block;
  margin-bottom: 0.5rem;
}

.protein-input-group input,
.protein-input-group select {
  padding: 0.7rem 0.75rem;
  font-size: 1.05rem;
  min-width: 120px;
  max-width: 220px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  background: #0f1621;
  color: var(--text);
  outline: none;
}

@media (prefers-color-scheme: light) {
  .protein-input-group input,
  .protein-input-group select {
    background: #fff;
    color: var(--text);
  }
}

/* Focus states for accessibility */
.protein-input-group input:focus-visible,
.protein-input-group select:focus-visible,
.protein-share-button:focus-visible,
.protein-input-group input[type="checkbox"]:focus-visible {
  outline: 2px solid var(--accent, #0a84ff);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--accent, #0a84ff) 30%, transparent);
}

/* ---------- CARDS ---------- */
.protein-input-card,
.protein-results-card,
.protein-disclaimer-card,
.protein-note-card,
.protein-sources-card {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 1.25rem;
  margin-bottom: 1.1rem;
}

.protein-results-card {
  background: var(--success-tint);
  border-color: var(--border-strong);
}

/* ---------- MUTED TEXT ---------- */
.protein-muted {
  color: var(--muted, #c9d1d9);
}

/* ---------- NOTE CARD ---------- */
.protein-note-card {
  padding: 1rem;
  border: 1px solid var(--border, #ccc);
  border-left: 4px solid var(--accent, #0a84ff);
  border-radius: 8px;
  background: rgba(255,255,255,0.07);
  margin-top: 0.75rem;
  margin-bottom: 1rem;
}

/* ---------- SOURCES CARD ---------- */
.protein-sources-card {
  padding: 1rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  background: var(--card, #fff);
}
.protein-source-list {
  margin: 0.5rem 0 0;
  padding-left: 1.15rem;
}
.protein-source-list li {
  margin: 0.35rem 0;
  color: var(--muted, #c9d1d9);
}

/* ---------- RESULTS ---------- */
.protein-results-card h2 {
  margin-top: 0;
}
.protein-results-card p {
  margin: 0.25rem 0;
  line-height: 1.45;
}
.protein-results-card strong {
  font-weight: 700;
}

/* ---------- DISCLAIMER ---------- */
.protein-disclaimer-card {
  border-style: dashed;
  font-size: 0.92rem;
}

/* ---------- FOOTER & BUTTON ---------- */
.protein-footer {
  margin-top: 1.25rem;
  text-align: center;
}

.protein-share-button {
  padding: 0.75rem 1.5rem;
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: var(--radius-md);
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
  transition: transform 120ms ease, background 160ms ease;
}
.protein-share-button:hover { background: var(--accent-hover); }
.protein-share-button:active { transform: translateY(1px) scale(0.99); }

/* ---------- RESPONSIVE ---------- */
@media (max-width: 520px) {
  .protein-tool-container { padding: 1.25rem 1rem; }
  .protein-input-group input,
  .protein-input-group select { width: 100%; max-width: 100%; }
  .protein-inline { gap: 0.4rem; }
}

/* ---------- REDUCED MOTION ---------- */
@media (prefers-reduced-motion: reduce) {
  .protein-share-button { transition: none; }
}

/* ---------- PRINT (optional) ---------- */
@media print {
  .protein-share-button,
  .protein-footer { display: none !important; }
  .protein-tool-container {
    box-shadow: none;
    background: #fff;
    color: #000;
  }
}`, "",{"version":3,"sources":["webpack://./src/ProteinIntakeCalculator.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,aAAa;EACb,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,oCAAoC;EACpC,mCAAmC;EACnC,0CAA0C;EAC1C,kBAAkB;EAClB,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;IACb,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,qCAAqC;IACrC,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;IAClB,0CAA0C;EAC5C;AACF;;AAEA;;WAEW,sBAAsB,EAAE;;AAEnC,oCAAoC;AACpC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA,uCAAuC;AACvC;IACI,aAAa;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE;;IAEE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA,mCAAmC;AACnC;;;;EAIE,yCAAyC;EACzC,iFAAiF;AACnF;;AAEA,gCAAgC;AAChC;;;;;EAKE,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA,qCAAqC;AACrC;EACE,4BAA4B;AAC9B;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,qCAAqC;EACrC,6CAA6C;EAC7C,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,kCAAkC;AAClC;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,cAAc;EACd,eAAe;EACf,uDAAuD;AACzD;AACA,8BAA8B,+BAA+B,EAAE;AAC/D,+BAA+B,sCAAsC,EAAE;;AAEvE,qCAAqC;AACrC;EACE,0BAA0B,qBAAqB,EAAE;EACjD;gCAC8B,WAAW,EAAE,eAAe,EAAE;EAC5D,kBAAkB,WAAW,EAAE;AACjC;;AAEA,yCAAyC;AACzC;EACE,wBAAwB,gBAAgB,EAAE;AAC5C;;AAEA,2CAA2C;AAC3C;EACE;oBACkB,wBAAwB,EAAE;EAC5C;IACE,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;EACb;AACF","sourcesContent":["/* ---------- THEME & RESETS ---------- */\n:root {\n  --bg: #0b0f14;\n  --card: rgba(255, 255, 255, 0.04);\n  --text: #f5f7fb;\n  --muted: #c9d1d9;\n  --accent: #0a84ff;\n  --accent-hover: #0066d9;\n  --success-tint: rgba(0, 180, 0, 0.1);\n  --border: rgba(255, 255, 255, 0.15);\n  --border-strong: rgba(255, 255, 255, 0.25);\n  --warning: #ffd166;\n  --shadow: 0 8px 32px rgba(0, 0, 0, 0.25);\n  --radius-lg: 12px;\n  --radius-md: 8px;\n  --radius-sm: 6px;\n}\n\n@media (prefers-color-scheme: light) {\n  :root {\n    --bg: #f7f9fc;\n    --card: #ffffff;\n    --text: #0f172a;\n    --muted: #475569;\n    --accent: #0a84ff;\n    --accent-hover: #0066d9;\n    --success-tint: rgba(0, 150, 0, 0.08);\n    --border: #e5e7eb;\n    --border-strong: #cbd5e1;\n    --warning: #b45309;\n    --shadow: 0 10px 30px rgba(2, 6, 23, 0.08);\n  }\n}\n\n*,\n*::before,\n*::after { box-sizing: border-box; }\n\n/* ---------- CONTAINER ---------- */\n.protein-tool-container {\n  max-width: 760px;\n  margin: 2rem auto;\n  background: var(--card);\n  color: var(--text);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow);\n  padding: 2.25rem 2rem;\n  backdrop-filter: saturate(140%) blur(4px);\n}\n\n.protein-tool-container h1 {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  font-size: clamp(1.4rem, 2.4vw, 1.9rem);\n}\n\n/* ---------- INPUT GROUPS ---------- */\n.protein-input-group {\n    display: flex;\n  margin-bottom: 1.1rem;\n}\n\n.protein-input-group label {\n  font-size: 1.05rem;\n  display: block;\n  margin-bottom: 0.5rem;\n}\n\n.protein-input-group input,\n.protein-input-group select {\n  padding: 0.7rem 0.75rem;\n  font-size: 1.05rem;\n  min-width: 120px;\n  max-width: 220px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border);\n  background: #0f1621;\n  color: var(--text);\n  outline: none;\n}\n\n@media (prefers-color-scheme: light) {\n  .protein-input-group input,\n  .protein-input-group select {\n    background: #fff;\n    color: var(--text);\n  }\n}\n\n/* Focus states for accessibility */\n.protein-input-group input:focus-visible,\n.protein-input-group select:focus-visible,\n.protein-share-button:focus-visible,\n.protein-input-group input[type=\"checkbox\"]:focus-visible {\n  outline: 2px solid var(--accent, #0a84ff);\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--accent, #0a84ff) 30%, transparent);\n}\n\n/* ---------- CARDS ---------- */\n.protein-input-card,\n.protein-results-card,\n.protein-disclaimer-card,\n.protein-note-card,\n.protein-sources-card {\n  background: var(--card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 1.25rem;\n  margin-bottom: 1.1rem;\n}\n\n.protein-results-card {\n  background: var(--success-tint);\n  border-color: var(--border-strong);\n}\n\n/* ---------- MUTED TEXT ---------- */\n.protein-muted {\n  color: var(--muted, #c9d1d9);\n}\n\n/* ---------- NOTE CARD ---------- */\n.protein-note-card {\n  padding: 1rem;\n  border: 1px solid var(--border, #ccc);\n  border-left: 4px solid var(--accent, #0a84ff);\n  border-radius: 8px;\n  background: rgba(255,255,255,0.07);\n  margin-top: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n/* ---------- SOURCES CARD ---------- */\n.protein-sources-card {\n  padding: 1rem;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  background: var(--card, #fff);\n}\n.protein-source-list {\n  margin: 0.5rem 0 0;\n  padding-left: 1.15rem;\n}\n.protein-source-list li {\n  margin: 0.35rem 0;\n  color: var(--muted, #c9d1d9);\n}\n\n/* ---------- RESULTS ---------- */\n.protein-results-card h2 {\n  margin-top: 0;\n}\n.protein-results-card p {\n  margin: 0.25rem 0;\n  line-height: 1.45;\n}\n.protein-results-card strong {\n  font-weight: 700;\n}\n\n/* ---------- DISCLAIMER ---------- */\n.protein-disclaimer-card {\n  border-style: dashed;\n  font-size: 0.92rem;\n}\n\n/* ---------- FOOTER & BUTTON ---------- */\n.protein-footer {\n  margin-top: 1.25rem;\n  text-align: center;\n}\n\n.protein-share-button {\n  padding: 0.75rem 1.5rem;\n  background: var(--accent);\n  color: #fff;\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: 1rem;\n  line-height: 1;\n  cursor: pointer;\n  transition: transform 120ms ease, background 160ms ease;\n}\n.protein-share-button:hover { background: var(--accent-hover); }\n.protein-share-button:active { transform: translateY(1px) scale(0.99); }\n\n/* ---------- RESPONSIVE ---------- */\n@media (max-width: 520px) {\n  .protein-tool-container { padding: 1.25rem 1rem; }\n  .protein-input-group input,\n  .protein-input-group select { width: 100%; max-width: 100%; }\n  .protein-inline { gap: 0.4rem; }\n}\n\n/* ---------- REDUCED MOTION ---------- */\n@media (prefers-reduced-motion: reduce) {\n  .protein-share-button { transition: none; }\n}\n\n/* ---------- PRINT (optional) ---------- */\n@media print {\n  .protein-share-button,\n  .protein-footer { display: none !important; }\n  .protein-tool-container {\n    box-shadow: none;\n    background: #fff;\n    color: #000;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
